import React, { useEffect } from "react";

export const useScrollPage = (to)=>{
    useEffect(()=>{
         window.scrollTo(0, to)
},[to])

}
